/**
 * Mutation pour l'import d'un brouillard de caisse via Excel (CECA).
 * Invalide les caches pour forcer le rafraîchissement.
 */
import { ApiMananger } from "actions/rtkquery";
import {
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_VENTES,
  INVALIDATE_DEPENSES,
  INVALIDATE_ECRITURE,
  INVALIDATE_COMPTE_PAIEMENT,
} from "../invalidationTags";

const importBrouillardApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    importBrouillardExcel: build.mutation({
      query: (formData) => ({
        url: "v1/brouillard/import-excel/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: [
        INVALIDATE_TRANSACTIONS,
        INVALIDATE_VENTES,
        INVALIDATE_DEPENSES,
        INVALIDATE_ECRITURE,
        INVALIDATE_COMPTE_PAIEMENT,
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useImportBrouillardExcelMutation } = importBrouillardApi;
